/**
 * Подпись «File type» в окне генерации — по самому файлу, а не по заказанному формату.
 *
 * Владелец 26.09: окно писало «WEBP», а в хранилище лежал PNG. Заказ и файл расходятся, когда провайдер или
 * наш адаптер формат не выполнили, и у моделей без выбора формата (у них в запросе всё равно лежит «png» по
 * умолчанию). Тип берём из расширения адреса оригинала; превью (`…_preview.webp`) — не оригинал, его не читаем.
 * Нет расширения (data:, blob:) — показываем заказанный формат, как раньше. jpg и jpeg — один формат: если
 * файл совпал с заказом, пишем так, как формат выбирали в виджете.
 */
const FAMILY: Record<string, string> = {
	jpg: 'jpeg',
	jpeg: 'jpeg',
	png: 'png',
	webp: 'webp',
	gif: 'gif',
	avif: 'avif',
	heic: 'heic',
	mp4: 'mp4',
	mov: 'mov',
	webm: 'webm',
}

/** Расширение файла по адресу (в нижнем регистре) или null: нет расширения, незнакомое, превью. */
export function fileExtOf(url?: string | null): string | null {
	if (!url || url.startsWith('data:') || url.startsWith('blob:')) return null
	const path = url.split(/[?#]/)[0]
	const slash = path.lastIndexOf('/')
	const dot = path.lastIndexOf('.')
	if (dot <= slash) return null
	if (/_preview\.[a-z0-9]+$/i.test(path)) return null
	const ext = path.slice(dot + 1).toLowerCase()
	return FAMILY[ext] ? ext : null
}

/** «PNG», «JPG», «WEBP»… — что на самом деле скачает человек; null — сказать нечего. */
export function fileTypeLabel(url?: string | null, requested?: string | null): string | null {
	const ext = fileExtOf(url)
	const req = (requested || '').trim().toLowerCase()
	if (ext) {
		if (req && FAMILY[req] === FAMILY[ext]) return req.toUpperCase()
		return ext === 'jpeg' ? 'JPG' : ext.toUpperCase()
	}
	return req ? req.toUpperCase() : null
}
